import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { isDepartmentSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';


const mapFilterData = (data: IDepartmentSearchForm): IDepartmentSearchPost | {} => {
  if (isDepartmentSearchFormEmpty(data) || data == undefined) { return {} };
  const removedUnusedFilters = filterNonEmptyValues(data);
  return removedUnusedFilters;
}

const getAllDepartments = async ( {data} : {data: IDepartmentSearchForm}): Promise<IGetDepartment> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;
  const response =  await axiosDefaultApi.post(`api/Search/Search/Departments?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData);
  return response as unknown as IGetDepartment;
};

type QueryFnType = typeof getAllDepartments;

type UseGetAllDepartmentsOptions = {
  data: IDepartmentSearchForm;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllDepartments = ({ data, config }: UseGetAllDepartmentsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllDepartments'],
    queryFn: () => getAllDepartments({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των διευθύνσεων.`, 500);
      setIsNotificationVisible(true);
      console.log(error);
    }
  });
};